
const manageEditCompanyAudioResources = 'manage.editCompany.audioResources'

const manageEditCompanyAudioResourcesConfig = {
  url: '/audioResources',
  component: 'companyAudioResources',
}

export { manageEditCompanyAudioResources, manageEditCompanyAudioResourcesConfig }
